<script lang="ts">
	import { run } from 'svelte/legacy';

	import { page } from '$app/stores';
	import { createDialog, melt } from '@melt-ui/svelte';
	import { fly, fade } from 'svelte/transition';
	import { t } from 'svelte-intl-precompile';

	import IconMenu from '$lib/assets/svg/icons/hamburger.svg?component';
	import IconClose from '$lib/assets/svg/icons/close.svg?component';
	import FirstLevelMenu from '../FirstLevelMenu/FirstLevelMenu.svelte';

	import { type MenuItem } from '$lib/utils/menu';

	interface Props {
		menu?: MenuItem[];
		onClose?: () => void;
	}

	let { menu = [], onClose }: Props = $props();

	const {
		elements: { trigger, overlay, content, close, portalled },
		states: { open }
	} = createDialog({
		defaultOpen: false,
		onOpenChange: ({ next }) => {
			return next;
		}
	});

	const getSelected = (path: string) => {
		const selected = menu.find((item) => item.onClick?.data === path || item.matcher?.(path));
		return selected ? selected.parent : null;
	};
	const onMenuChange = (detail: string) => {
		selectedTopLevelItem = detail;
	};

	let innerWidth = $state(0);
	run(() => {
		if (innerWidth > 860) {
			$open = false;
		}
	});

	let selectedTopLevelItem = $derived(getSelected($page.url.pathname));
</script>

<svelte:window bind:innerWidth />

<button
	use:melt={$trigger}
	class="SidebarMobile__trigger"
	data-testid="SidebarMobile"
	class:SidebarMobile__trigger--active={$open}
>
	<span class="SidebarMobile__trigger-label">
		{$t('menu.menu')}
	</span>
	<span class="SidebarMobile__trigger-icon">
		<IconMenu></IconMenu>
	</span>
</button>

<div use:melt={$portalled}>
	{#if $open}
		<div
			use:melt={$overlay}
			class="SidebarMobile__overlay"
			transition:fade={{ duration: 300 }}
		></div>
		<div class="SidebarMobile__container">
			<div
				class="SidebarMobile__wrapper"
				transition:fly={{ duration: 150, x: -100 }}
				use:melt={$content}
			>
				<div class="SidebarMobile__close-wrapper">
					<button
						use:melt={$close}
						aria-label="close"
						class="SidebarMobile__close"
						onclick={() => onClose?.()}
						><IconClose></IconClose>
					</button>
				</div>
				<div class="SideBarMobile__content">
					<FirstLevelMenu
						onpagechange={() => {
							$open = false;
						}}
						{menu}
						onChange={onMenuChange}
						selectedItem={selectedTopLevelItem}
					></FirstLevelMenu>
				</div>
			</div>
		</div>
	{/if}
</div>

<style src="./SideBarMobile.scss" lang="scss"></style>
